import { useState } from 'react';

export const useExamHook = () => {
  const [isTimeExpired, setIsTimeExpired] = useState<boolean>(false);
  const [isOpenPrint, setIsOpenPrint] = useState<boolean>(false);
  const [isOpenFinishConfirmation, setIsOpenFinishConfirmation] =
    useState<boolean>(false);
  const [isOpenAnswerCard, setIsOpenAnswerCard] = useState<boolean>(false);

  const confirmEndOfExam = (isTimeExpired?: boolean) => {
    if (isTimeExpired) {
      setIsTimeExpired(isTimeExpired);
    }

    setIsOpenFinishConfirmation(true);
  };

  return {
    isOpenPrint,
    isOpenAnswerCard,
    isTimeExpired,
    isOpenFinishConfirmation,
    confirmEndOfExam,
    setIsOpenPrint,
    setIsOpenAnswerCard,
    setIsOpenFinishConfirmation,
  };
};
